import {
  ModalProps,
  createUseModal,
  useFormModal,
} from "@imminently/react/context/modals";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@imminently/react/ui/core/dialog";
import { Text } from "@imminently/react/ui/core/text";

const styles = {
  modalContent: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    paddingBottom: 4,
    paddingTop: 2,
  },
};

import { PatientEncounter } from "@/resources/types";
import { PatientCard } from "@/components/PatientCard";


interface PatientSummaryModalProps {
  encounter: PatientEncounter;
}

const PatientSummaryModal = ({ props }: ModalProps<PatientSummaryModalProps>) => {
  const { encounter } = props;

  const { close } = useFormModal({
    mode: "all",
  });

  return (
    <Dialog open onClose={() => close()} maxWidth={"md"}>
      <DialogTitle>
        <Text variant="h4">Patient Summary</Text>
      </DialogTitle>

      <DialogContent sx={styles.modalContent}>
        <PatientCard encounter={encounter} overrideStyle={{
          width: "50vw"
        }} />
      </DialogContent>
    </Dialog>
  );
};

export const usePatientSummaryModal = createUseModal(PatientSummaryModal);
